import { createApiClient } from '@app/api';
import { createRouterUtils } from '@orpc/tanstack-query';

export { createApiClient } from '@app/api';

export const client = createApiClient();
export const api = createRouterUtils(client);
